export default "__VITE_ASSET__CuFXV908__"